export enum GoustoHeaders {
  XGoustoTestEmailAddress = 'x-gousto-test-email-address',
}
